import { createStore } from 'jotai';
import {
  diagnosticsModeAtom,
  dodAtom,
  sizeAtom,
  sliceAreaAtom,
  unitAtom,
  zoomAreaAtom,
  logAxisAtom,
  primaryFilterVisibilityAtom,
} from '@components/metrics-panel-hz/atoms';
import { dimensionPanelAtom, metricPanelAtom, summaryPanelAtom } from '@src/atoms/panels';
import { aiAlertAtom, manualAlertAtom } from '@src/atoms/toggles';

function initStore(state = {}) {
  const store = createStore();

  if ('metricPanel' in state) {
    const {
      size = 's',
      unit = '%',
      sliceArea = null,
      zoomArea = null,
      diagnosticsMode = false,
      logAxis = false,
      primaryFilterVisibility = true,
    }: any = state.metricPanel;

    store.set(sizeAtom, size);
    store.set(unitAtom, unit);
    store.set(sliceAreaAtom, sliceArea);
    store.set(zoomAreaAtom, zoomArea);
    store.set(diagnosticsModeAtom, diagnosticsMode);
    store.set(logAxisAtom, logAxis);
    store.set(primaryFilterVisibilityAtom, primaryFilterVisibility);
  }

  if ('toggles' in state) {
    const { sections, diagnostics } = state.toggles;
    if (sections) {
      const { summary = true, metric = true, dimension = true } = sections;
      store.set(summaryPanelAtom, summary);
      store.set(metricPanelAtom, metric);
      store.set(dimensionPanelAtom, dimension);
    }
    if (diagnostics) {
      const { manualAlert = false, aiAlert = false, dod = false } = diagnostics;
      store.set(manualAlertAtom, manualAlert);
      store.set(aiAlertAtom, aiAlert);
      store.set(dodAtom, dod);
    }
  }

  return store;
}

export default initStore;
